import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tooltip } from 'components/core/Tooltip';
import { IconBanner } from 'components/core/IconBanner';
import InfoIcon from 'components/svg/InfoIcon';

import './TooltipBanner.scss';

export function TooltipBanner({
	tooltipContent,
	bannerIcon,
	theme,
	textColor,
	bannerText,
	tooltipIcon,
	last,
	className,
}) {
	return (
		<Tooltip
			className={classnames('tooltip-banner', className, { last })}
			content={tooltipContent}
		>
			<div className="tooltip-icon"> {tooltipIcon} </div>
			<IconBanner
				className="icon-banner"
				icon={bannerIcon}
				theme={theme}
				textColor={textColor}
				bannerText={bannerText}
			/>
		</Tooltip>
	);
}

TooltipBanner.propTypes = {
	tooltipContent: PropTypes.string,
	theme: PropTypes.oneOf(['orange']),
	bannerIcon: PropTypes.element,
	textColor: PropTypes.string,
	bannerText: PropTypes.string,
	tooltipIcon: PropTypes.element,
	last: PropTypes.bool,
	className: PropTypes.string,
};

TooltipBanner.defaultProps = {
	tooltipIcon: <InfoIcon />,
};

export default TooltipBanner;
